import {withNamespaces} from "react-i18next";
import React from "react";

const HERO_ASSETS = {
  'training-day': {
    desktop: '/images/booking/training-day-banner-2026-10-17.jpg',
    mobile: '/images/booking/training-day-banner-mobile-2026-10-17.jpg',
    alt: 'training-day-hero',
  },
  crunchone: {
    desktop: '/images/booking/coko-banner-desktop.jpg',
    mobile: '/images/booking/coko-logo-white.png',
    alt: 'crunch-hero',
  },
  promo: {
    desktop: '/images/booking/coko-promo-banner-desktop.jpg',
    mobile: '/images/booking/coko-promo-banner-desktop.jpg',
    alt: 'crunch-hero',
  },
};

const BookingHeroComponent = (props) => {
  var assetKey = props.eventType || 'crunchone';
  if (assetKey === 'crunchone' && props.isPromotion) assetKey = 'promo';
  const assets = HERO_ASSETS[assetKey] || HERO_ASSETS.crunchone;
  return (
    <div className="booking-hero">
      <img className='hero-logo hero-desktop' src={assets.desktop} alt={assets.alt} />
      <img className='hero-logo hero-mobile' src={assets.mobile} alt={assets.alt} />
    </div>
  );
};

export default withNamespaces()(BookingHeroComponent);
